import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import FadeModal from "reboron/FadeModal";

class ConfirmModal extends Component {
  constructor(props) {
    super(props);
    this.state = { data: null };
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const { id, modal } = nextProps;

    if (modal !== this.props.modal) {
      if (id === modal.id && modal.show) {
        this.modal.show();
        const { data } = modal;
        if (modal.data) this.setState({ data });
      } else {
        this.modal.hide();
      }
    }
  };

  confirm = () => {
    this.close(false);
    this.props.confirm(this.state.data);
  };

  close = (wasCanceled) => {
    const { close, id } = this.props;
    close(id, wasCanceled);
  };

  render() {
    const {
      id,
      size,
      title,
      body,
      footer,
      actions,
      disabled,
      confirmLabel,
      cancelLabel,
      showHeader,
      showCancel,
      closeOnClick
    } = this.props;

    return (
      <div id={id}>
        <FadeModal
          ref={(ref) => (this.modal = ref)}
          className="confirm-modal"
          closeOnClick={closeOnClick}
        >
          <div className={`modal-${size}`}>
            {showHeader && (
              <div className="modal-header">
                <button
                  type="button"
                  className="close"
                  onClick={() => this.close(true)}
                >
                  ×
                </button>
                <h2 className="modal-title">{title}</h2>
              </div>
            )}

            <div className="modal-body">
              <p>{body}</p>
            </div>
            <div className="modal-footer">
              {actions || (
                <button
                  disabled={disabled}
                  className="btn btn-success"
                  type="button"
                  onClick={this.confirm}
                >
                  {confirmLabel}
                </button>
              )}
              {showCancel && (
                <button
                  className="btn btn-default"
                  type="button"
                  onClick={() => this.close(true)}
                >
                  {cancelLabel}
                </button>
              )}
              {footer}
            </div>
          </div>
        </FadeModal>
      </div>
    );
  }
}

ConfirmModal.propTypes = {
  id: PropTypes.string.isRequired,
  size: PropTypes.string,
  title: PropTypes.string.isRequired,
  body: PropTypes.node.isRequired,
  footer: PropTypes.string,
  confirm: PropTypes.func,
  close: PropTypes.func,
  modal: PropTypes.object,
  actions: PropTypes.node,
  disabled: PropTypes.bool,
  confirmLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  showHeader: PropTypes.bool,
  showCancel: PropTypes.bool,
  closeOnClick: PropTypes.bool
};

ConfirmModal.defaultProps = {
  size: "md",
  confirm: () => null,
  confirmLabel: "Confirm",
  cancelLabel: "Cancel",
  disabled: false,
  showHeader: true,
  showCancel: true,
  closeOnClick: true
};

function mapStatesToProps(state) {
  return {
    state: state.reducers,
    modal: state.reducers.modal
  };
}

export default connect(mapStatesToProps)(ConfirmModal);
